import React from "react";
import "./SocialMedia.css";
import { ImLinkedin, ImTwitter } from "react-icons/im";
import { FaGithub } from "react-icons/fa";
import { IconContext } from "react-icons";
import { TbMailFilled } from "react-icons/tb";

export default function socialMedia(props) {
  return (
    <div className="social-media-div">
      My Social Profiles :
      <a
        href="https://www.linkedin.com/in/alan-binu"
        className={`icon-button`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconContext.Provider
          value={{
            className: "react-icon-class",
          }}
        >
          <ImLinkedin />
        </IconContext.Provider>
      </a>
      <a
        href="https://twitter.com/AlanBinuTeacher"
        className={`icon-button`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconContext.Provider
          value={{
            className: "react-icon-class",
          }}
        >
          <ImTwitter />
        </IconContext.Provider>
      </a>
      <a
        href="https://github.com/alanbinu007"
        className={`icon-button`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconContext.Provider
          value={{
            className: "react-icon-class",
          }}
        >
          <FaGithub />
        </IconContext.Provider>
      </a>
      <a
        href="mailto:alanbinu5@gmail.com"
        className={`icon-button`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <IconContext.Provider
          value={{
            className: "react-icon-class",
          }}
        >
          <TbMailFilled />
        </IconContext.Provider>
      </a>
    </div>
  );
}
